/* The line `export const base_url = "";` is exporting a constant variable
named `base_url` with the value `""`. This means that the `base_url`
variable can be accessed and used in other modules or files that import this module. */

export const Token = process.env.REACT_APP_GUEST_USER_TOKEN;